module.exports = __webpack_public_path__ + "img/190125_AM_Gutscheine.5ccfc5fc.jpg";